<template>
  <div class="spring2025">
    <div class="spring2023-style">
      <div class="wrap">
        <header class="header">
          <img src="../assets/images/spring2025/头部.png" width="100%" />
        </header>
        <div class="spring-weather">
          <div class="head">
            <span class="title">春运天气</span>
            <span class="date">广州市气象台{{ springWeatherDate }}发布</span>
          </div>
          <div class="content">
            <a href="http://tqyb.com.cn/data/link-tqbg/" target="_blank">
              {{ springWeatherContent }}
            </a>
          </div>
        </div>
        <div class="row">
          <div class="important-traffic">
            <el-tabs v-model="trafficActiveName">
              <el-tab-pane :label="key" :name="key" v-for="(value, key) in importantTrafficInfo" :key="key">
                <div class="important-traffic-pic" :style="'background: url(' +
                  require('../assets/images/spring2022/' +
                    value.ename +
                    '.png') +
                  ') center 0 / cover no-repeat;'
                  "></div>
                <div class="important-traffic-weather">
                  <div class="important-traffic-real">
                    <ul>
                      <li class="temp">
                        <span>{{ value.t }}℃</span><span>温度</span>
                      </li>
                      <li class="rain">
                        <span>{{ value.hourrf }}mm</span><span>雨量</span>
                      </li>
                      <li class="hum">
                        <span>{{ value.rh }}%</span><span>相对湿度</span>
                      </li>
                      <li class="wind-speed">
                        <span>{{ value.wd2df }}m/s</span><span>风速</span>
                      </li>
                      <li class="wind-direction">
                        <span>{{
                          value.wd2dd === "--"
                            ? value.wd2dd
                            : windCont[Math.floor((value.wd2dd + 22.5) / 45)]
                        }}</span><span>风向</span>
                      </li>
                    </ul>
                  </div>
                  <div class="important-traffic-forcast" :id="`hour-forcast-chart-${value.ename}`"></div>
                </div>
              </el-tab-pane>
            </el-tabs>
          </div>
          <div class="atuo-station">
            <el-tabs v-model="autoStatiionActiveName">
              <el-tab-pane label="广州各区实况" name="0">
                <div class="area">
                  <div class="area-item">
                    <template v-for="(value, key, index) in areas">
                      <button :class="activeArea === key ? 'active' : ''" v-if="index < 5" @click="changeArea(key)"
                        :key="key">
                        {{ value }}
                      </button>
                    </template>
                  </div>
                  <div class="area-item">
                    <template v-for="(value, key, index) in areas">
                      <button :class="activeArea === key ? 'active' : ''" v-if="index >= 5" @click="changeArea(key)"
                        :key="key">
                        {{ value }}
                      </button>
                    </template>
                  </div>
                </div>
                <div class="real">
                  <div class="real-weather">
                    <img src="../assets/images/spring2022/temp.png" />
                    <div class="decscription">
                      <span class="temp">{{ activeAreaData.t }}℃</span>
                    </div>
                  </div>
                  <div class="real-weather-element">
                    <div class="item">
                      <img src="../assets/images/spring2022/湿度(1).png" /><span>{{ activeAreaData.rh }}%</span>
                    </div>
                    <div class="item">
                      <img src="../assets/images/spring2022/风速(1).png" /><span>{{ activeAreaData.wdidf }}m/s</span>
                    </div>
                    <div class="item">
                      <img src="../assets/images/spring2022/风向.png" /><span>{{
                        activeAreaData.wdidd === "--"
                          ? activeAreaData.wdidd
                          : windCont[
                          Math.floor((activeAreaData.wdidd + 22.5) / 45)
                          ]
                      }}</span>
                    </div>
                    <div class="item">
                      <img src="../assets/images/spring2022/雨量(1).png" /><span>{{ activeAreaData.hourrf }}mm</span>
                    </div>
                  </div>
                </div>
                <div class="publish-time">
                  广州市气象台{{
                    activeAreaData.ddatetime
                      ? new Date(activeAreaData.ddatetime).format(
                        "yyyy年MM月dd日hh时mm分"
                      )
                      : ""
                  }}发布
                </div>
              </el-tab-pane>
              <el-tab-pane label="交通气象站" name="1">
                <div class="area">
                  <div class="area-item">
                    <template v-for="(value, key, index) in trafficStationData">
                      <button :class="activeStation === key ? 'active' : ''" v-if="index < 5"
                        @click="changeTrafficStation(key)" :key="key">
                        {{ value.name }}
                      </button>
                    </template>
                  </div>
                </div>
                <div class="real">
                  <div class="real-weather">
                    <img src="../assets/images/spring2022/地面温度.png" width="55" />
                    <div class="decscription">
                      <span class="temp">{{ activeTrafficStationData.temp }}℃</span>
                    </div>
                  </div>
                  <div class="real-weather-element">
                    <div class="item">
                      <img src="../assets/images/spring2022/风速(1).png" /><span>{{ activeTrafficStationData.wdidf
                        }}m/s</span>
                    </div>
                    <div class="item">
                      <img src="../assets/images/spring2022/风向.png" /><span>{{
                        activeTrafficStationData.wdidd === "--"
                          ? activeTrafficStationData.wdidd
                          : windCont[
                          Math.floor(
                            (activeTrafficStationData.wdidd + 22.5) / 45
                          )
                          ]
                      }}</span>
                    </div>
                    <div class="item">
                      <img src="../assets/images/spring2022/雨量(1).png" /><span>{{ activeTrafficStationData.hourrf
                        }}mm</span>
                    </div>
                  </div>
                </div>
                <div class="publish-time">
                  广州市气象台{{
                    activeTrafficStationData.ddatetime
                      ? new Date(activeTrafficStationData.ddatetime).format(
                        "yyyy年MM月dd日hh时mm分"
                      )
                      : ""
                  }}发布
                </div>
              </el-tab-pane>
            </el-tabs>
          </div>
        </div>
        <div class="row">
          <div class="road">
            <el-tabs v-model="roadActiveName">
              <!-- <el-tab-pane label="广州市重点通道实时路况" name="0" class="road-real">
                <iframe width="99.5%" height="99.5%" src="http://tqyb.com.cn/road1/"></iframe>
              </el-tab-pane> -->
              <el-tab-pane label="广州重要交通枢纽精细化预报" name="0">
                <div class="sevenDays">
                  <seven-days-gift-map ref="sevenDaysGift" :showTitle="false"></seven-days-gift-map>
                  <button @click="closeBox">关闭</button>
                </div>
                <div id="map"></div>
              </el-tab-pane>
              <el-tab-pane label="全国公路气象预报" name="1">
                <div class="road-forecast" v-html="roadForecast"></div>
              </el-tab-pane>
            </el-tabs>
          </div>
        </div>
        <div class="row">
          <div class="left">
            <div class="ticket">
              <div class="head">
                <span class="title">购票天气日历</span>
                <span class="date">[注]日历中标注订票时间为最早订票时间</span>
              </div>
              <div class="content">
                <div class="left-button">
                  <button @click="clickTicket(-1)"></button>
                </div>
                <div class="ticket-list">
                  <div class="ticket-list-item" v-for="item in ticketData.slice(
                    ticketIndex * 8,
                    (ticketIndex + 1) * 8
                  )" :key="item.date">
                    <div class="buy-ticket-date">票 {{ item.pdate }}</div>
                    <div class="current-date">{{ item.date }}</div>
                    <div :class="`text ${item.weekStyle ? 'future-date' : ''}`" v-if="!item.icon">
                      {{ item.number }}
                    </div>
                    <div class="weather-icon" v-if="item.icon">
                      <img :src="require('../assets/images/weatherIcon/' +
                        item.icon +
                        '.png')
                        " />
                    </div>
                    <div class="lunar">{{ item.LunarDayStr }}</div>
                  </div>
                </div>
                <div class="right-button">
                  <button @click="clickTicket(1)"></button>
                </div>
              </div>
            </div>
            <div class="outside">
              <el-tabs v-model="outsideActiveName">
                <el-tab-pane label="出省天气" name="0">
                  <div id="cityMap"></div>
                  <div class="days-forecast" v-show="daysForecastShow">
                    <div class="days-forecast-title">
                      <span>{{ daysForecast.name }}</span>
                      <button @click="() => (daysForecastShow = false)"></button>
                    </div>
                    <div class="days-forecast-content">
                      <div class="days-forecast-item" v-for="item in daysForecast.data" :key="item.date">
                        <div class="date">{{ item.date }}</div>
                        <div class="week">{{ item.week }}</div>
                        <div class="weather-icon">
                          <img :src="require('../assets/images/weatherIcon/' +
                            item.icon +
                            '.png')
                            " />
                        </div>
                        <div class="weather-decscription">{{ item.desc }}</div>
                        <div class="temp">{{ item.t }}℃</div>
                      </div>
                    </div>
                    <div class="days-forecast-time">
                      {{ daysForecast.ptime }}发布
                    </div>
                  </div>
                </el-tab-pane>
                <el-tab-pane label="全国春运天气" name="1">
                  <div class="spring-weather" v-html="springWeather"></div>
                </el-tab-pane>
              </el-tabs>
            </div>
          </div>
          <div class="right">
            <div class="warning">
              <div class="head">
                <span class="title">预警信号</span>
              </div>
              <div class="content">
                <alarm-signal></alarm-signal>
              </div>
            </div>
            <div class="weibo">
              <div class="head">
                <span class="title">天气微博</span>
              </div>
              <div class="content">
                <iframe height="700" width="100%" src="https://m.weibo.cn/u/2294193132"></iframe>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="international">
            <div class="head">
              <span class="title">国际城市预报</span>
              <span class="date">{{
                internationalPtime
                  ? new Date(internationalPtime).format(
                    "yyyy年MM月dd日hh时mm分"
                  )
                  : ""
              }}</span>
            </div>
            <div class="content">
              <div class="continent">
                <div :class="`continent-item ${activeContinent === key ? 'active' : ''
                  }`" v-for="(value, key) in internationalData" :key="key" @click="() => (activeContinent = key)">
                  {{ key }}
                </div>
              </div>
              <div class="citys">
                <div class="city" v-for="item in internationalData[activeContinent]" :key="item.city">
                  <p>{{ item.city }}</p>
                  <p>{{ item.mint }}～{{ item.maxt }}℃</p>
                  <p>{{ item.wcont }}</p>
                  <p>{{ item.windd }} {{ item.winds }}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <footer class="footer">
        <div class="wrap footer-wrap">
          <div class="copyright">
            <h3>版权声明</h3>
            <p>版权所有©广州市气象台</p>
            <p>
              <a target="_blank" href="http://www.miibeian.gov.cn/">粤ICP备 06082644号</a>
            </p>
            <p>Copyright(C) 2017-2019</p>
            <p>by Guangzhou Meteorological Service All Rights Reserved</p>
          </div>
          <div class="contact-us">
            <h3>联系我们</h3>
            <p>广州市番禺区大石植村工业一路68号</p>
            <p>天气咨询：12121</p>
            <p>联系电话：020-66619588</p>
            <p>传真：020-66619585</p>
          </div>
          <div class="focus-us">
            <h3>关注我们</h3>
            <p>拿出手机 [ 扫一扫 ]</p>
            <p>
              <img src="../assets/images/spring2022/wxm.png" />
            </p>
          </div>
        </div>
        <!-- <div class="footer-bg">
          <img src="../assets/images/spring2023/底部.png" width="100%" />
        </div> -->
      </footer>
    </div>
  </div>
</template>
<script>
import { spring2022 } from '@/api/index.js'
import echarts from '@/config/echarts/index.js'
import { twentyFourHourForecastOptions } from '@/config/echarts/option/spring2022.js'
import sevenDaysGiftMap from '../components/HomeChild/sevenDaysGiftMap.vue'
import BMap from 'BMap'
import BMapLib from '@/assets/js/BMapLib_GeoUtils.js'
import AMap from 'AMap'
import AlarmSignal from '../components/HomeChild/alarmSignal.vue'
import { getLunar } from 'chinese-lunar-calendar'
export default {
  name: 'spring2022',
  data() {
    return {
      springWeatherDate: '',
      springWeatherContent: '',
      importantTrafficInfo: {
        广州南站: { obtid: 'G3324', ename: 'gznz', lon: 113.275824, lat: 22.994826 },
        广州站: { obtid: 'G3222', ename: 'gzz', lon: 113.264437, lat: 23.154981 },
        广州东站: { obtid: 'G3241', ename: 'gzdz', lon: 113.331062, lat: 23.155823 },
        白云机场: { obtid: '59284', ename: 'byjc', lon: 113.314282, lat: 23.395352 },
        广州北站: { obtid: 'G3241', ename: 'gzbz', lon: 113.331062, lat: 23.155823 },
        南沙客运港: { obtid: '59284', ename: 'nskyg', lon: 113.314282, lat: 23.395352 }
      },
      obtData: '',
      windCont: ['北风', '东北风', '东风', '东南风', '南风', '西南风', '西风', '西北风', '北风'],
      trafficActiveName: '广州南站',
      autoStatiionActiveName: 0,
      areas: {
        GDHX: '花都区',
        GDCO: '从化区',
        GDZC: '增城区',
        GDPY: '番禺区',
        GDHH: '海珠区',
        GDLW: '荔湾区',
        GDTH: '天河区',
        GDNS: '南沙区',
        GDBY: '白云区',
        GDHU: '黄埔区'
      },
      activeArea: '',
      areaData: '',
      activeAreaData: {
        t: '',
        rh: '',
        wdidf: '',
        wd2dd: '',
        hourrf: '',
        ddatetime: ''
      },
      trafficStation: {
        G9701: { name: '乐广高速梯面出口互通区' },
        G9702: { name: '大广高速吕田服务区' },
        G9703: { name: '肇花高速红群出口' },
        G9704: { name: '北三环高速心岭村' },
        G9705: { name: '广河高速知识城出口' },
        G9706: { name: '北环高速沙贝服务区' },
        G9707: { name: '广州白云国际机场' },
        G9708: { name: '广州站' },
        G9709: { name: '广州东站' },
        G9710: { name: '广州南站' }
      },
      trafficStationData: '',
      activeStation: '',
      activeTrafficStationData: {
        temp: '',
        wdidf: '',
        wdidd: '',
        hourrf: '',
        ddatetime: ''
      },
      roadActiveName: '0',
      cPoint: [111.8, 23.835916],
      chezhanArray: [
        { name: '省汽车客运站', addr: '广州市环市西路147-149号', point: [113.259719, 23.154236] },
        { name: '市汽车客运站', addr: '广州市环市西路158号', point: [113.259647, 23.153439] },
        { name: '天河客运站', addr: '燕岭路633号', point: [113.35038, 23.176465] },
        { name: '芳村汽车客运站', addr: '广州花地大道中51号', point: [113.240797, 23.086168] },
        { name: '越秀南客运站', addr: '广州市越秀南路东园横路2号', point: [113.2841, 23.124776] },
        { name: '罗冲围客运站', addr: '广州市增槎路251—255号', point: [113.229581, 23.154394] },
        { name: '滘口汽车站', addr: '芳村大道西533号', point: [113.21489, 23.121095] },
        { name: '广园客运站', addr: '广州市广园中路283号', point: [113.278874, 23.165135] },
        { name: '海珠客运站', addr: '广州南洲路182号', point: [113.306333, 23.0703] },
        { name: '广佛汽车站', addr: '广州市中山八路95号', point: [113.239814, 23.130991] },
        { name: '东圃客运站', addr: '广州市中山大道东1011号', point: [113.422365, 23.125607] },
        { name: '夏茅汽车站', addr: '机场路夏茅村口', point: [113.267433, 23.235239] },
        { name: '永泰汽车站', addr: '白云大道北271号（临）', point: [113.314347, 23.242818] },
        { name: '黄埔客运站', addr: '广州市黄埔广深公路以南石化路以东段', point: [113.474726, 23.102523] },
        { name: '东站客运站', addr: '广州市天河区禺东西路43号', point: [113.329778, 23.158548] },
        { name: '南站客运站', addr: '广州市番禺区钟村南站南路', point: [113.280885, 22.995918] }
      ],
      chezhanMarketArray: [],
      matouMarketArray: [],
      matouArray: [
        { name: '西堤码头', addr: '西堤码头', point: [113.258575, 23.11321] },
        { name: '广州塔码头', addr: '广州塔码头', point: [113.32743, 23.113093] },
        { name: '金沙洲码头', addr: '金沙洲码头', point: [113.221552, 23.161347] }
      ],

      gangkouMarketArray: [],
      gangkouArray: [
        { name: '广州港', addr: '广州港', point: [113.458388, 23.099748] },
        { name: '南沙港', addr: '南沙港', point: [113.596377, 22.80594] },
        { name: '莲花山港', addr: '莲花山港', point: [113.513031, 22.973551] }
      ],

      huocheMarketArray: [],
      huocheArray: [
        { name: '广州站', addr: '广州站', point: [113.264213, 23.154868] },
        { name: '广州东站', addr: '广州东站', point: [113.332205, 23.156263] },
        { name: '广州南站', addr: '广州南站', point: [113.277259, 22.995818] },
        { name: '广州北站', addr: '广州北站', point: [113.211203, 23.382947] }
      ],
      feijiMarketArray: [],
      feijiArray: [
        { name: '白云机场', addr: '白云机场', point: [113.309493, 23.392435] }

      ],
      yjMarketArray: [],
      yjpointArray: [
        { name: '广东奥林匹克体育中心', addr: '广东奥林匹克体育中心', point: [113.416811, 23.145979] },
        { name: '黄埔区体育中心', addr: '黄埔区体育中心', point: [113.463035, 23.12077] },
        { name: '广州体育馆', addr: '广州体育馆', point: [113.284057, 23.187879] },
        { name: '广交会展馆', addr: '广交会展馆', point: [113.367982, 23.107182] },
        { name: '广州体育学院', addr: '广州体育学院', point: [113.325457, 23.149434] },
        { name: '天河体育中心', addr: '天河体育中心', point: [113.33143, 23.143957] },
        { name: '大学城体育中心', addr: '大学城体育中心', point: [113.397292, 23.0609] },
        { name: '大学城广东科学中心', addr: '大学城广东科学中心', point: [113.369063, 23.045285] },
        { name: '花都区体育中心', addr: '花都区体育中心', point: [113.22666, 23.390722] },
        { name: '花都区实验中学', addr: '花都区实验中学', point: [113.218168, 23.382401] },
        { name: '花都区秀全中学', addr: '花都区秀全中学', point: [113.216759, 23.448906] },
        { name: '新华街第二小学', addr: '新华街第二小学', point: [113.217722, 23.380975] },
        { name: '花都区邝维煜中学', addr: '花都区邝维煜中学', point: [113.210722, 23.405983] },
        { name: '花都区圆玄中学', addr: '花都区圆玄中学', point: [113.221263, 23.415293] },
        { name: '花都区云山中学', addr: '花都区云山中学', point: [113.234923, 23.402337] },
        { name: '花都区体育馆', addr: '花都区体育馆', point: [113.217526, 23.385418] }],
      roadForecast: '',
      nowDate: new Date(),
      weeks: ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六'],
      madd: new Array(12),
      tgString: '甲乙丙丁戊己庚辛壬癸',
      dzString: '子丑寅卯辰巳午未申酉戌亥',
      numString: '一二三四五六七八九十',
      monString: '正二三四五六七八九十冬腊',
      weekString: '日一二三四五六',
      sx: '鼠牛虎兔龙蛇马羊猴鸡狗猪',
      ticketData: [],
      ticketIndex: 0,
      outsideActiveName: 0,
      daysForecastShow: false,
      daysForecast: {
        name: '',
        ptime: '',
        data: []
      },
      springWeather: '',
      internationalData: {},
      internationalPtime: '',
      activeContinent: ''
    }
  },
  async created() {
    this.getSpringWeather()
    this.obtData = await spring2022.getMainObtData()
    this.formatObtData()
    this.getImportantTraffic()
    this.changeArea('GDHX')
    this.changeTrafficStation('G9704')
    this.trafficHinge()
    this.getRoadForecastData()
    this.ticketCalendar()
    this.getSpringWeatherCountry()
    this.getInternationalData()
    this.aroundCity()
    window.showDaysForecast = this.showDaysForecast
  },
  mounted() {

  },
  methods: {
    /**
     * 春运天气
     */
    async getSpringWeather() {
      const res = await spring2022.getSpringWeather()
      if (res && res.length > 0) {
        this.springWeatherContent = res[0]
        this.springWeatherDate = res[1]
      }
    },
    /**
     * 四站一场一港
     */
    async getImportantTraffic() {
      const ddate = new Date()
      const hour = ddate.getHours()
      let startIndex = 0
      let endIndex = 0
      if (hour < 7) {
        startIndex = hour + 4
      } else if (hour > 7 && hour < 18) {
        startIndex = hour - 8
      } else {
        startIndex = hour - 19
      }
      endIndex = startIndex + 24
      for (const key in this.importantTrafficInfo) {
        const element = this.importantTrafficInfo[key]
        // 实况数据
        if (this.obtData && this.obtData[key]) {
          this.importantTrafficInfo[key] = { ...this.obtData[key], ...element }
        }
        // 预报数据
        const res = await spring2022.getGiftDailyData(element.lon, element.lat)
        const optionData = {
          tempGroup: [],
          rainGroup: [],
          windGroup: [],
          xText: []
        }
        let ddhour = hour + 1
        for (let i = startIndex; i < endIndex; i++) {
          optionData.tempGroup.push(res.gift_t[i])
          optionData.rainGroup.push(res.gift_rain[i])
          optionData.windGroup.push(res.gift_winds[i])
          if (ddhour === 24) {
            ddhour = 0
          }
          optionData.xText.push(ddhour + '时')
          ddhour++
        }
        const myChart = echarts.init(document.getElementById('hour-forcast-chart-' + element.ename))
        myChart.setOption(twentyFourHourForecastOptions(optionData))
      }
    },
    /**
     * 广州各区实况
     */
    async changeArea(key) {
      if (this.activeArea !== key) {
        this.activeArea = key
        if (this.areaData === '') {
          const res = await spring2022.getObtAreaRep()
          for (const key in res) {
            const data = res[key]
            const rv = data['z']
            if (typeof rv === 'undefined') {
              continue
            }
            for (const key in data) {
              if (key != 'ddatetime' && key != 'z') {
                data[key] = Math.round((data[key] - 999) / rv) / 10.0
              }
            }
          }
          if (res) {
            for (const key in res) {
              for (const k in res[key]) {
                res[key][k] = res[key][k] === -999.9 ? '--' : res[key][k]
              }
            }
            this.areaData = res
          } else {
            return
          }
        }
        if (this.areaData[this.activeArea] && this.areaData[this.activeArea] !== 'null') {
          this.activeAreaData = this.areaData[this.activeArea]
        }
      }
    },
    /**
     * 气象交通站
     */
    async changeTrafficStation(key) {
      if (this.activeStation !== key) {
        this.activeStation = key
        if (this.trafficStationData === '') {
          const res = await spring2022.getTrafficsObt()
          if (res) {
            for (const item in res.data) {
              res.data[item].name = this.trafficStation[item].name
              for (const element in res.data[item]) {
                res.data[item][element] = res.data[item][element] === -999.9 || res.data[item][element] === '-999.9' || res.data[item][element] === -9999 ? '--' : res.data[item][element]
              }
            }
            this.trafficStationData = res.data
          } else {
            return
          }
        }
        if (this.trafficStationData[this.activeStation] && this.trafficStationData[this.activeStation] !== 'null') {
          this.activeTrafficStationData = this.trafficStationData[this.activeStation]
        }
      }
    },
    /**
     * 广州重要交通枢纽精细化预报
     */
    trafficHinge() {
      this.map = new BMap.Map('map')
      this.map.centerAndZoom(new BMap.Point(this.cPoint[0], this.cPoint[1]), 10)
      this.map.addControl(new BMap.NavigationControl())
      this.map.addControl(new BMap.ScaleControl())
      this.map.addControl(new BMap.MapTypeControl({ anchor: BMAP_ANCHOR_TOP_RIGHT, mapTypes: [BMAP_SATELLITE_MAP, BMAP_HYBRID_MAP, BMAP_NORMAL_MAP] }))
      this.map.enableScrollWheelZoom()
      this.showBoundary('广州')
      this.map.setCurrentCity('广州')
      this.map.addEventListener('click', this.loadDataAndChange)
    },
    showBoundary(city) {
      const thisObj = this
      const bdary = new BMap.Boundary()
      bdary.get(city, function (rs) {
        thisObj.map.clearOverlays()
        var count = rs.boundaries.length
        for (var i = 0; i < count; i++) {
          thisObj.gzPolygon = new BMap.Polygon(rs.boundaries[i], { strokeWeight: 2, strokeColor: '#ff0000', fillColor: null, fillOpacity: 0.1, strokeStyle: 'dashed' }) // 建立多边形覆盖物
          thisObj.map.addOverlay(thisObj.gzPolygon)
        }
        thisObj.mapMarker = new BMap.Marker(new BMap.Point(thisObj.cPoint[0], thisObj.cPoint[1])) // 创建标注
        thisObj.map.addOverlay(thisObj.mapMarker)
        thisObj.serchCheZhan(1)
        thisObj.serchCheZhan(2)
        thisObj.serchCheZhan(3)
        thisObj.serchCheZhan(4)
        thisObj.serchCheZhan(5)
        thisObj.serchCheZhan(6)
        // thisObj.initMapCallbac()
      })
    },
    serchCheZhan(index) {
      const thisObj = this
      let itm = null
      if (index === 1) {
        for (let i = 0; i < thisObj.chezhanArray.length; i++) {
          itm = thisObj.chezhanArray[i]
          thisObj.chezhanMarketArray[i] = new BMap.Marker(new BMap.Point(itm.point[0], itm.point[1]),
            { icon: new BMap.Icon('http://tqyb.com.cn/designs/zhuanti/img/chezhan.png', new BMap.Size(20, 25), { anchor: new BMap.Size(10, 25) }), title: itm.name })
          thisObj.map.addOverlay(thisObj.chezhanMarketArray[i])
          thisObj.chezhanMarketArray[i].addEventListener('click', function () {
            thisObj.sp_click = true
            // $('#jxh-position').html('当前位置：' + this.getTitle())
            return false
          })
        }
      } else if (index === 2) {
        for (let i = 0; i < thisObj.matouArray.length; i++) {
          itm = thisObj.matouArray[i]
          thisObj.matouMarketArray[i] = new BMap.Marker(new BMap.Point(itm.point[0], itm.point[1]),
            { icon: new BMap.Icon('http://tqyb.com.cn/designs/zhuanti/img/matou.png', new BMap.Size(20, 25), { anchor: new BMap.Size(10, 25) }), title: itm.name })
          thisObj.map.addOverlay(thisObj.matouMarketArray[i])
          thisObj.matouMarketArray[i].addEventListener('click', function () {
            thisObj.sp_click = true
            // $('#jxh-position').html('当前位置：' + this.getTitle())
            return false
          })
        }
      } else if (index === 3) {
        for (let i = 0; i < thisObj.gangkouArray.length; i++) {
          itm = thisObj.gangkouArray[i]
          thisObj.gangkouMarketArray[i] = new BMap.Marker(new BMap.Point(itm.point[0], itm.point[1]),
            { icon: new BMap.Icon('http://tqyb.com.cn/designs/zhuanti/img/gangkou.png', new BMap.Size(20, 25), { anchor: new BMap.Size(10, 25) }), title: itm.name })
          thisObj.map.addOverlay(thisObj.gangkouMarketArray[i])
          thisObj.gangkouMarketArray[i].addEventListener('click', function () {
            thisObj.sp_click = true
            // $('#jxh-position').html('当前位置：' + this.getTitle())
            return false
          })
        }
      } else if (index === 4) {
        for (let i = 0; i < thisObj.huocheArray.length; i++) {
          itm = thisObj.huocheArray[i]
          thisObj.huocheMarketArray[i] = new BMap.Marker(new BMap.Point(itm.point[0], itm.point[1]),
            { icon: new BMap.Icon('http://tqyb.com.cn/designs/zhuanti/img/hc2019.png', new BMap.Size(36, 46), { anchor: new BMap.Size(10, 25) }), title: itm.name })
          thisObj.map.addOverlay(thisObj.huocheMarketArray[i])
          thisObj.huocheMarketArray[i].addEventListener('click', function () {
            thisObj.sp_click = true
            // $('#jxh-position').html('当前位置：' + this.getTitle())
            return false
          })
        }
      } else if (index === 5) {
        for (let i = 0; i < thisObj.feijiArray.length; i++) {
          itm = thisObj.feijiArray[i]
          thisObj.feijiMarketArray[i] = new BMap.Marker(new BMap.Point(itm.point[0], itm.point[1]),
            { icon: new BMap.Icon('http://tqyb.com.cn/designs/zhuanti/img/jc2019.png', new BMap.Size(36, 46), { anchor: new BMap.Size(10, 25) }), title: itm.name })
          thisObj.map.addOverlay(thisObj.feijiMarketArray[i])
          thisObj.feijiMarketArray[i].addEventListener('click', function () {
            thisObj.sp_click = true
            // $('#jxh-position').html('当前位置：' + this.getTitle())
            return false
          })
        }
      } else if (index === 6) {
        for (var i = 0; i < thisObj.yjpointArray.length; i++) {
          itm = thisObj.yjpointArray[i]
          thisObj.yjMarketArray[i] = new BMap.Marker(new BMap.Point(itm.point[0], itm.point[1]),
            { icon: new BMap.Icon('http://tqyb.com.cn/designs/zhuanti/img/yj.png', new BMap.Size(24, 30), { anchor: new BMap.Size(10, 25) }, { imageOffset: new BMap.Size(0, 0) }), title: itm.name })
          thisObj.map.addOverlay(thisObj.yjMarketArray[i])
          thisObj.yjMarketArray[i].addEventListener('click', function () {
            thisObj.sp_click = true
            // $('#jxh-position').html('当前位置：' + this.getTitle())
            return false
          })
        }
      }
    },
    loadDataAndChange(e) {
      // $('#forecast-popup').hide()
      var thisObj = this
      if (BMapLib.GeoUtils.isPointInPolygon(new BMap.Point(e.point.lng, e.point.lat), thisObj.gzPolygon) === false) {
        alert('超出查询范围！ 请选择广州范围内的点。')
      }
      thisObj.cPoint[0] = e.point.lng
      thisObj.cPoint[1] = e.point.lat
      // var httpUrl = thisObj.baiduApi + thisObj.cPoint[1] + ',' + thisObj.cPoint[0]

      thisObj.mapMarker.show()
      thisObj.mapMarker.setPosition(new BMap.Point(thisObj.cPoint[0], thisObj.cPoint[1]))
      // vanwins.view.createScriptNoCache(httpUrl, null)

      // thisObj.loadData(thisObj.cPoint[0], thisObj.cPoint[1])
      this.$refs.sevenDaysGift.refresh(thisObj.cPoint)

      const sevenContainer = document.getElementsByClassName('sevenDays')[0]
      sevenContainer.style.display = 'block'
    },
    /**
     * 关闭7天弹窗
     */
    closeBox() {
      const sevenContainer = document.getElementsByClassName('sevenDays')[0]
      sevenContainer.style.display = 'none'
    },
    /**
     * 全国公路气象预报
     */
    async getRoadForecastData() {
      const res = await spring2022.getHighwayForecast()
      if (res) {
        this.roadForecast = res.data
      }
    },
    /**
     * 购票天气日历
     */
    async ticketCalendar() {
      const now = new Date()
      const ticketTime = new Date()
      ticketTime.setTime(now.getTime() + 14 * 8.64e7)
      const res = await spring2022.getWeatherForecastByDays()
      for (let i = 1; i <= 40; i++) {
        const lunar = getLunar(now.getFullYear(), now.getMonth() + 1, now.getDate())
        const LunarDayStr = lunar.dateStr.substring(2)
        const weekStyle = (this.weeks[now.getDay()] === '星期日' || this.weeks[now.getDay()] === '星期六')
        const pNum = (now.getTime() - this.nowDate.getTime()) / (24 * 3600000)
        let icon
        if (pNum >= 1 && pNum <= 7) {
          icon = res.BCGZ.icons_f[parseInt(pNum)]
        }
        const pdate = ticketTime.format('M.d')
        this.ticketData.push({ pdate, LunarDayStr, number: now.format('d'), date: now.format('M月d日'), weekStyle, icon })
        now.setTime(now.getTime() + 24 * 3600000)
        ticketTime.setTime(ticketTime.getTime() + 24 * 3600000)
      }
    },
    clickTicket(num) {
      if (this.ticketIndex + num > 4) {
        this.ticketIndex = 0
      } else if (this.ticketIndex + num < 0) {
        this.ticketIndex = 4
      } else {
        this.ticketIndex += num
      }
    },
    /**
     * 出省天气
     */
    aroundCity() {
      // 周边城市
      this.cmap = new AMap.Map('cityMap', {
        resizeEnable: true,
        mapStyle: 'amap://styles/9f64cf8eb4f9c4a300c672c73a6d257d',
        center: [115.503951, 25.892709],
        zoom: 6,
        pitch: 0
        /* zoomEnable:false,
        dragEnable: false, */
      })
      console.log(this.cmap)
      this.cmap.setDefaultCursor('default')
      var driving = new AMap.Driving({
        map: this.cmap,
        autoFitView: false,
        hideMarkers: true,
        policy: AMap.DrivingPolicy.LEAST_TIME
      })
      driving.search([113.267198, 23.13119], [112.945246, 28.238432])
      var driving2 = new AMap.Driving({
        map: this.cmap,
        autoFitView: false,
        hideMarkers: true,
        policy: AMap.DrivingPolicy.LEAST_TIME
      })
      driving2.search([113.267198, 23.13119], [114.794175, 28.513668])
      var driving3 = new AMap.Driving({
        map: this.cmap,
        autoFitView: false,
        hideMarkers: true,
        policy: AMap.DrivingPolicy.LEAST_TIME
      })
      driving3.search([113.267198, 23.13119], [116.831676, 28.469985])
      var driving4 = new AMap.Driving({
        map: this.cmap,
        autoFitView: false,
        hideMarkers: true,
        policy: AMap.DrivingPolicy.LEAST_TIME
      })
      driving4.search([113.267198, 23.13119], [117.599763, 26.211078])
      var driving5 = new AMap.Driving({
        map: this.cmap,
        autoFitView: false,
        hideMarkers: true,
        policy: AMap.DrivingPolicy.LEAST_TIME
      })
      driving5.search([117.599763, 26.211078], [119.480887, 26.007597])
      var driving6 = new AMap.Driving({
        map: this.cmap,
        autoFitView: false,
        hideMarkers: true,
        policy: AMap.DrivingPolicy.LEAST_TIME
      })
      driving6.search([113.267198, 23.13119], [119.549877, 26.699618])

      var driving7 = new AMap.Driving({
        map: this.cmap,
        autoFitView: false,
        hideMarkers: true,
        policy: AMap.DrivingPolicy.LEAST_TIME
      })
      driving7.search([113.267198, 23.13119], [111.749423, 28.311353])
      var driving8 = new AMap.Driving({
        map: this.cmap,
        autoFitView: false,
        hideMarkers: true,
        policy: AMap.DrivingPolicy.LEAST_TIME
      })
      driving8.search([113.267198, 23.13119], [108.366465, 22.817927])
      console.log('定位拨错')
      setTimeout(function () {
        this.cmap.setStatus({
          dragEnable: false,
          zoomEnable: false
        })
      }, 2000)
      this.provinceAlarmURL = '/gzWeather/otherCityAlarm.js'// 省内天气预警
      this.provinceCity = null// 省内城市
      this.provinceAlarm = null// 国内预警
      this.city = {
        BCGZ: { name: '广州市', top: -60, left: -90, lat: '23.1290800000', lon: '113.2643600000' },
        BFSG: { name: '韶关', top: 10, left: -10, lat: '24.807901', lon: '113.594434' },
        BFEY: { name: '河源', top: 10, left: -10, lat: '23.761222', lon: '114.687099' },
        BFMZ: { name: '梅州', top: 10, left: -10, lat: '24.303055', lon: '116.115322' },
        BFCO: { name: '潮州', top: 10, left: -10, lat: '23.670695', lon: '116.631679' },
        BFDG: { name: '东莞', top: 10, left: -10, lat: '23.04537', lon: '113.736781' },
        BFSE: { name: '深圳', top: 10, left: -10, lat: '22.554169', lon: '114.077358' },
        BFHP: { name: '惠州', top: 10, left: -10, lat: '23.080749', lon: '114.406947' },
        BFSW: { name: '汕尾', top: 10, left: -10, lat: '22.777201', lon: '115.357265' },
        BFJY: { name: '揭阳', top: 10, left: -10, lat: '23.544859', lon: '116.346034' },
        BFST: { name: '汕头', top: 10, left: -10, lat: '23.378571', lon: '116.70309' },
        BFQY: { name: '清远', top: 10, left: -10, lat: '23.690817', lon: '113.044643' },
        BFFO: { name: '佛山', top: 10, left: -10, lat: '23.030205', lon: '113.116054' },
        BFYP: { name: '云浮', top: 10, left: -10, lat: '22.934119', lon: '112.039394' },
        BFZN: { name: '中山', top: 10, left: -10, lat: '22.518653', lon: '113.379726' },
        BFJB: { name: '江门', top: 10, left: -10, lat: '22.589676', lon: '113.088588' },
        BFYV: { name: '阳江', top: 10, left: -10, lat: '21.862525', lon: '111.973476' },
        BFMM: { name: '茂名', top: 10, left: -10, lat: '21.658456', lon: '110.918788' },
        BFZJ: { name: '湛江', top: 10, left: -10, lat: '21.280168', lon: '110.352992' },
        BFZH: { name: '珠海', top: 10, left: -10, lat: '22.056955', lon: '113.340262' },
        BFZQ: { name: '肇庆', top: 10, left: -10, lat: '23.054606', lon: '112.469424' },
        zhangsha: { name: '长沙市', top: -70, left: -50, lat: '28.2277800000', lon: '112.9388600000' },
        nanchang: { name: '南昌市', top: 18, left: -50, lat: '28.6820200000', lon: '115.8579400000' },
        nanning: { name: '南宁市', top: -70, left: -50, lat: '22.8167300000', lon: '108.3669000000' },
        fuzhou: { name: '福州市', top: -70, left: -76, lat: '26.0742100000', lon: '119.2964700000' },
        guiyang: { name: '贵阳市', top: -70, left: -50, lat: '26.67865', lon: '106.62298' }
      }
      console.log('定位拨错')
      this.loadCityPoint()
    },
    async loadCityPoint() {
      this.provinceCity = await spring2022.getProvinceCityForecast()
      this.domesticCity = await spring2022.getDomesticCityForecast()
      console.log('定位拨错')
      console.log(this.provinceCity, this.domesticCity)
      this.provinceCity.data.zhangsha = this.domesticCity.data.zhangsha
      this.provinceCity.data.nanchang = this.domesticCity.data.nanchang
      this.provinceCity.data.nanning = this.domesticCity.data.nanning
      this.provinceCity.data.fuzhou = this.domesticCity.data.fuzhou
      this.provinceCity.data.guiyang = this.domesticCity.data.guiyang
      for (var item in this.city) {
        var cityData = this.city[item]
        var data = this.provinceCity.data[item][0]
        var Name = this.city[item].name
        if (Name.indexOf('市') > 0) {
          // eslint-disable-next-line no-new
          new AMap.Marker({
            position: new AMap.LngLat(cityData.lon, cityData.lat),
            map: this.cmap,
            anchor: 'center',
            offset: new AMap.Pixel(0, 0),
            content: '<div class="citys" onclick="javascript:showDaysForecast(\'' + item + '\',\'' + Name + '\',this);"><div class="point"></div><div ' +
              'class="detailWrapper" style="top: ' + cityData.top + 'px;left: ' + cityData.left + 'px;"><div class="cityName">' + cityData.name + '</div><div class="weather">' + data.cont + '</div><div class="temperature">' + data.mint + '℃/' + data.maxt + '℃</div></div></div>'
          })
        } else {
          // eslint-disable-next-line no-new
          new AMap.Marker({
            position: new AMap.LngLat(cityData.lon, cityData.lat),
            map: this.cmap,
            anchor: 'center',
            offset: new AMap.Pixel(0, 0),
            content: '<div class="citys" onclick="javascript:showDaysForecast(\'' + item + '\',\'' + Name + '\',this);"><div class="point"></div><div ' +
              'class="shengnei" style="top: ' + cityData.top + 'px;left: ' + cityData.left + 'px;"><div class="cityName">' + cityData.name + '</div></div></div>'
          })
        }
      }
    },
    showDaysForecast(item, Name, node) {
      // this.showTable(this.provinceCity, item)
      const weekDay = ['星期天', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六']
      const ptime = new Date(this.provinceCity.ptime).format('yyyy年MM月dd日 hh时mm分')
      const data = []
      for (let i = 0; i < 3; i++) {
        const pdate = new Date(this.provinceCity.ptime + (i + 1) * 8.64e7)
        const date = pdate.format('MM月dd日')
        const week = weekDay[pdate.getDay()]
        const desc = this.provinceCity.data[item][i].cont
        const icon = this.getICON(desc)
        const t = this.provinceCity.data[item][i].mint + '-' + this.provinceCity.data[item][i].maxt
        data.push({ date, week, desc, icon, t })
      }
      this.daysForecast.name = Name
      this.daysForecast.ptime = ptime
      this.daysForecast.data = data
      this.daysForecastShow = true
    },
    getICON(desc) {
      var iconNum = '00'
      if (desc === '晴天') {
        iconNum = '00'
      } else if (desc === '灰霾') {
        iconNum = '53'
      } else if (desc === '多云') {
        iconNum = '01'
      } else if (desc === '阴') {
        iconNum = '02'
      } else if (desc === '阵雨') {
        iconNum = '03'
      } else if (desc === '雷阵雨') {
        iconNum = '04'
      } else if (desc === '冰雹') {
        iconNum = '05'
      } else if (desc === '雨夹雪') {
        iconNum = '06'
      } else if (desc === '小雨') {
        iconNum = '07'
      } else if (desc === '中雨') {
        iconNum = '08'
      } else if (desc === '大雨') {
        iconNum = '09'
      } else if (desc === '暴雨') {
        iconNum = '10'
      } else if (desc === '大暴雨') {
        iconNum = '11'
      } else if (desc === '特大暴雨') {
        iconNum = '12'
      } else if (desc === '阵雪') {
        iconNum = '13'
      } else if (desc === '小雪') {
        iconNum = '14'
      } else if (desc === '中雪') {
        iconNum = '15'
      } else if (desc === '暴雪') {
        iconNum = '17'
      } else if (desc === '雾霾' || desc === '雾') {
        iconNum = '18'
      } else if (desc === '小到中雨') {
        iconNum = '21'
      } else if (desc === '中到大雨') {
        iconNum = '22'
      } else if (desc === '大到暴雨') {
        iconNum = '23'
      } else if (desc === '暴雨到大暴雨') {
        iconNum = '24'
      } else if (desc === '大暴雨到特大暴雨') {
        iconNum = '25'
      } else if (desc === '浮尘') {
        iconNum = '29'
      } else if (desc === '扬沙') {
        iconNum = '30'
      } else if (desc === '强沙尘暴') {
        iconNum = '31'
      } else if (desc === '雾霾') {
        iconNum = '53'
      }
      return iconNum
    },
    /**
     * 全国春运天气
     */
    async getSpringWeatherCountry() {
      const res = await spring2022.getSpringWeatherCountry()
      if (res) {
        this.springWeather = res.data
      }
    },
    /**
    * 国际城市预报
    */
    async getInternationalData() {
      const res = await spring2022.getInternationalData()
      if (res) {
        this.internationalData = res
        this.activeContinent = Object.keys(res)[0]
        this.internationalPtime = res[this.activeContinent][0].ddatetime
      }
    },
    /**
     * 格式化自动站数据
     */
    formatObtData() {
      if (this.obtData) {
        for (const key in this.obtData) {
          for (const element in this.obtData[key]) {
            this.obtData[key][element] = this.obtData[key][element] === -999.9 || this.obtData[key][element] === '-999.9' ? '--' : this.obtData[key][element]
          }
        }
      }
    }
  },
  components: {
    sevenDaysGiftMap,
    AlarmSignal
  }
}
// eslint-disable-next-line no-extend-native
Date.prototype.format = function (fmt) {
  var o = {
    'M+': this.getMonth() + 1, // 月份
    'd+': this.getDate(), // 日
    'h+': this.getHours(), // 小时
    'm+': this.getMinutes(), // 分
    's+': this.getSeconds(), // 秒
    'q+': Math.floor((this.getMonth() + 3) / 3), // 季度
    S: this.getMilliseconds() // 毫秒
  }
  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(RegExp.$1, (this.getFullYear() + '').substr(4 - RegExp.$1.length))
  }
  for (var k in o) {
    if (new RegExp('(' + k + ')').test(fmt)) {
      fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? (o[k]) : (('00' + o[k]).substr(('' + o[k]).length)))
    }
  }
  return fmt
}
</script>
<style lang="less" scoped>
.spring2025 {
  font-family: PingFangSC-Regular, PingFang SC;
  min-width: 1240px;
  background: #d3302b;

  .spring2023-style {
    background: url("../assets/images/spring2025/底图.png") no-repeat;
    background-size: contain;
  }

  // @media screen and (max-width: 1800px) {
  //   .spring2023-style {
  //     background: transparent;
  //   }
  // }

  .wrap {
    position: relative;
    z-index: 1;
    width: 1400px;
    margin: 0 auto;

    .header {
      img {
        display: block;
      }
    }

    .spring-weather {
      background: #ffffff;
      border-radius: 10px;
      padding: 15px 20px;

      .head {
        .title {
          background: url("../assets/images/spring2022/春运天气.png") no-repeat -30px;
        }
      }

      .content {
        a {
          text-decoration: none;
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #333333;
          line-height: 30px;
        }
      }
    }

    .head {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 10px;

      .title {
        font-size: 16px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #333333;
        display: block;
        padding-left: 30px;
      }

      .date {
        color: #999999;
        font-size: 12px;
      }
    }

    .content {
      color: #333333;
      font-size: 14px;
    }

    .row {
      margin: 20px 0 0;
      display: flex;

      .important-traffic {
        background: #ffffff;
        border-radius: 10px;
        padding: 0 20px 15px;
        width: 65%;

        /deep/.el-tab-pane {
          display: flex;
          align-items: center;

          .important-traffic-pic {
            flex: 1;
            height: 320px;
            border-radius: 6px;
            background-size: cover;
          }

          .important-traffic-weather {
            margin-left: 20px;

            .important-traffic-real {
              ul {
                display: flex;
                justify-content: space-between;
                margin: 0;
                padding: 0;

                li {
                  list-style: none;
                  width: 92px;
                  height: 56px;
                  padding: 20px 10px 0 0;

                  span {
                    text-align: center;
                    display: block;
                    font-size: 14px;
                    color: #333333;
                  }

                  span:first-child {
                    font-size: 16px;
                    font-family: PingFangSC-Medium, PingFang SC;
                  }
                }

                li:last-child {
                  padding: 20px 0 0 0;
                }

                .temp {
                  background: url("../assets/images/spring2022/温度.png") no-repeat;
                }

                .rain {
                  background: url("../assets/images/spring2022/雨量.png") no-repeat;
                }

                .hum {
                  background: url("../assets/images/spring2022/湿度.png") no-repeat;
                }

                .wind-speed {
                  background: url("../assets/images/spring2022/风速.png") no-repeat;
                }

                .wind-direction {
                  background: url("../assets/images/spring2022/北风.png") no-repeat;
                }
              }
            }

            .important-traffic-forcast {
              height: 248px;
              width: 500px;
            }
          }
        }
      }

      .atuo-station {
        flex: 1;
        background: #ffffff;
        border-radius: 10px;
        margin-left: 20px;
        padding: 0 20px;

        .area {
          .area-item {
            display: flex;
            flex-wrap: wrap;
            margin-bottom: 10px;

            button {
              background-color: transparent;
              border: 0;
              height: 30px;
              border-radius: 17px;
              border: 1px solid #eeeeee;
              color: #333333;
              font-size: 14px;
              padding: 0 10px;
              margin: 5px 7px;
            }

            .active {
              background: rgba(190, 32, 37, 0.04);
              border: 1px solid #be2025;
            }
          }
        }

        .real {
          border-radius: 6px;
          border: 1px solid #eeeeee;
          padding: 20px;

          .real-weather {
            display: flex;
            align-items: center;

            .decscription {
              margin-left: 10px;

              .dec {
                color: #333333;
                font-size: 14px;
                display: block;
                margin-left: 5px;
              }

              .temp {
                display: block;
                font-size: 40px;
                font-family: PingFangSC-Medium, PingFang SC;
                font-weight: 500;
                color: #333333;
              }
            }
          }

          .real-weather-element {
            display: flex;
            justify-content: space-between;
            margin: 20px 0;

            .item {
              display: flex;
              align-items: center;
              padding: 0 0 0 10px;

              span {
                margin-left: 8px;
                color: #333333;
                font-size: 14px;
              }
            }
          }
        }

        .publish-time {
          color: #999999;
          font-size: 12px;
          text-align: center;
          margin: 20px 0;
        }
      }

      .road {
        background: #ffffff;
        border-radius: 10px;
        padding: 0 20px 20px;
        flex: 1;

        .el-tab-pane {
          height: 580px;

          iframe {
            border: 2px solid #eeeeee;
          }

          .sevenDays {
            width: 790px;
            position: absolute;
            bottom: 0;
            z-index: 1;
            border: 10px solid skyblue;
            padding: 20px 10px;
            background-color: white;

            button {
              position: absolute;
              top: 0;
              right: 0;
            }
          }

          #map {
            height: 100%;
          }

          .road-forecast {
            height: 580px;
            overflow: auto;

            /deep/.title {
              color: red;
              font-size: 34px;
              font-weight: bold;
              padding: 10px;
              text-align: center;
              height: 40px;
              line-height: 40px;
            }

            /deep/.author {
              font-size: 14px;
              padding: 10px 0;
              text-align: center;
            }
          }
        }
      }

      .left {
        width: 69%;

        .ticket {
          background: #ffffff;
          border-radius: 10px;
          padding: 15px 20px;
          height: 200px;

          .head {
            .title {
              background: url("../assets/images/spring2022/购票天气日历.png") no-repeat -9px;
            }
          }

          .content {
            display: flex;
            justify-content: space-between;
            align-items: center;

            .left-button {
              button {
                background: url("../assets/images/spring2022/左滑.png") no-repeat;
                border: 0;
                width: 23px;
                height: 47px;
              }
            }

            .right-button {
              button {
                background: url("../assets/images/spring2022/右滑.png") no-repeat;
                border: 0;
                width: 23px;
                height: 47px;
              }
            }

            .ticket-list {
              flex: 1;
              display: flex;
              justify-content: space-between;
              padding: 0 5px;

              .ticket-list-item {
                text-align: center;
                padding: 0 15px;
                border-radius: 6px;
                border: 1px solid #eeeeee;

                .buy-ticket-date {
                  background: #85db6f;
                  border-radius: 10px;
                  color: #ffffff;
                  font-size: 12px;
                  text-align: center;
                  width: 62px;
                  height: 20px;
                  line-height: 20px;
                  margin-top: 15px;
                }

                .current-date {
                  font-size: 12px;
                  color: #333333;
                  margin-top: 13px;
                }

                .text {
                  width: 38px;
                  height: 38px;
                  background: #92c6fd;
                  color: #ffffff;
                  font-size: 14px;
                  border-radius: 50%;
                  text-align: center;
                  line-height: 38px;
                  margin: 0 auto;
                  margin-top: 11px;
                }

                .future-date {
                  background: red;
                }

                .lunar {
                  margin-top: 12px;
                  font-size: 12px;
                  color: #333333;
                  margin-bottom: 22px;
                }

                .weather-icon {
                  margin-top: 12px;

                  img {
                    height: 33px;
                  }
                }
              }
            }
          }
        }

        .outside {
          background: #ffffff;
          border-radius: 10px;
          padding: 0 20px 20px;
          margin-top: 20px;

          .el-tab-pane {
            height: 855px;

            #cityMap {
              height: 100%;

              /deep/.citys {
                position: relative;
                cursor: pointer;

                .point {
                  width: 10px;
                  height: 10px;
                  border-radius: 50%;
                  background: #f40000;
                }

                .detailWrapper {
                  position: absolute;
                  text-align: center;
                  font-weight: bold;
                  line-height: 22px;
                  color: #ffffff;
                  width: 100px;
                  border-radius: 10px;
                  background: rgba(0, 0, 0, 0.4);
                }

                .shengnei {
                  position: absolute;
                  text-align: center;
                  line-height: 15px;
                  width: 30px;
                  font-size: 13px;
                  color: #7b7a7a;
                }
              }
            }

            .days-forecast {
              position: absolute;
              right: 30px;
              top: 30px;
              background: #ffffff;
              box-shadow: 0px 0px 9px 0px rgba(0, 0, 0, 0.17);
              border-radius: 6px;

              .days-forecast-title {
                font-size: 14px;
                font-family: PingFangSC-Medium, PingFang SC;
                font-weight: 500;
                color: #333333;
                display: flex;
                padding: 15px 10px 10px;
                align-items: center;
                justify-content: space-between;
                border-bottom: 1px solid #eeeeee;

                span {
                  display: inline-block;
                  background: url("../assets/images/spring2022/地址.png") no-repeat;
                  padding-left: 20px;
                }

                button {
                  border: 0;
                  background: url("../assets/images/spring2022/关闭.png") no-repeat;
                  width: 9px;
                  height: 9px;
                }
              }

              .days-forecast-content {
                padding: 10px;
                display: flex;
                width: 300px;
                justify-content: space-between;

                .days-forecast-item {
                  font-size: 12px;
                  font-family: PingFangSC-Regular, PingFang SC;
                  font-weight: 400;
                  color: #333333;
                  text-align: center;
                  width: 93px;
                  height: 180px;
                  background: #ffffff;
                  border-radius: 6px;
                  border: 1px solid #eeeeee;

                  .date {
                    margin: 16px 0 7px 0;
                  }

                  .weather-icon {
                    margin: 9px 0 11px 0;

                    img {
                      width: 48px;
                    }
                  }

                  .weather-decscription {
                    margin-bottom: 6px;
                  }
                }
              }

              .days-forecast-time {
                font-size: 12px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #999999;
                text-align: center;
                margin-bottom: 10px;
              }
            }

            .spring-weather {
              height: 100%;
              overflow: auto;

              /deep/.title {
                color: red;
                font-size: 34px;
                font-weight: bold;
                padding: 10px;
                text-align: center;
                height: 40px;
                line-height: 40px;
              }

              /deep/.author {
                font-size: 14px;
                padding: 10px 0;
                text-align: center;
              }

              /deep/.subhead {
                font-size: 18px;
                font-weight: bold;
                text-align: center;
                padding-bottom: 10px;
              }
            }
          }
        }
      }

      .right {
        flex: 1;
        margin-left: 20px;

        .warning {
          background: #ffffff;
          border-radius: 10px;
          padding: 15px 20px;

          .head {
            margin-bottom: 0;

            .title {
              background: url("../assets/images/spring2022/预警信号.png") no-repeat -19px;
            }
          }

          .content {
            height: 355px;

            /deep/.el-tabs__item {
              font-size: 14px;
              height: 25px;
              line-height: 25px;
              padding: 0 10px;
            }

            /deep/.alarmSignal {
              a {
                text-decoration: none;
                font-size: 12px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #666666;
                top: 15px;
              }
            }
          }
        }

        .weibo {
          background: #ffffff;
          border-radius: 10px;
          padding: 15px 20px;
          margin-top: 20px;

          iframe {
            border: 0;
          }

          .head {
            .title {
              background: url("../assets/images/spring2022/天气微博.png") no-repeat -16px;
            }
          }
        }
      }

      .international {
        background: #ffffff;
        border-radius: 10px;
        padding: 15px 20px;
        //margin-top: 20px;
        width: 100%;

        .head {
          .title {
            background: url("../assets/images/spring2022/国际城市预报.png") no-repeat -13px;
          }
        }

        .content {
          display: flex;
          justify-content: space-between;

          .continent {
            margin-right: 10px;

            .continent-item {
              width: 76px;
              height: 30px;
              border: 1px solid transparent;
              font-size: 16px;
              font-family: PingFangSC-Medium, PingFang SC;
              font-weight: 500;
              color: #333333;
              text-align: center;
              line-height: 30px;
              margin-bottom: 14px;
            }

            .active {
              background: rgba(190, 32, 37, 0.04);
              border-radius: 15px;
              border: 1px solid #be2025;
            }
          }

          .citys {
            display: flex;
            flex-wrap: wrap;
            flex: 1;
            justify-content: space-between;

            .city {
              font-size: 14px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: #333333;
              background: rgba(189, 35, 37, 0.04);
              border-radius: 4px;
              text-align: center;
              padding: 9px 0;
              width: 107px;
              margin-bottom: 10px;
              height: 130px;

              p {
                padding: 0;
                margin: 9px 0 0 0;
              }
            }
          }
        }
      }

      /deep/.el-tabs__nav {
        margin: 10px 0 0;

        .el-tabs__item {
          font-size: 16px;
          color: #666666;
        }

        .is-active {
          color: #bd2325;
        }

        .el-tabs__active-bar {
          background: #bd2325;
          border-radius: 2px;
        }
      }

      /deep/.el-tabs__nav-wrap::after {
        background-color: transparent;
      }
    }
  }

  .footer {
    background: #a3001a;
    margin-top: 20px;
    padding: 10px 0;
    position: relative;

    .footer-wrap {
      display: flex;
      justify-content: space-between;

      h3 {
        font-size: 18px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #ffffff;
      }

      p {
        font-size: 16px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #ffffff;
        margin-block-end: 0;
        margin-block-start: 0;
        margin-bottom: 13px;

        a {
          color: #ffffff;
          text-decoration: none;
        }

        img {
          height: 80px;
          border-radius: 4px;
        }
      }
    }

    .footer-bg {
      position: absolute;
      left: 0;
      right: 0;
      bottom: 213px;
      z-index: 0;
    }
  }

  @media (max-width: 1440px) {
    .wrap {
      width: 1240px;
      min-width: 1240px;
    }
  }
}
</style>
